import React, { useContext } from 'react'
import { Select } from 'antd'
import { IsApp } from '../../../../../contexts';
import CustomJSComp from './ChoiceOptions/Types/CustomJS';

import { 
  ExecJS,
} from '../../../../../../../records/choice_config_records';

const PreferencesActionOptions = ({ settingsTitle, updateSetting, value, settingKey, features }) => {
  const isApp = useContext(IsApp)

  const hasFeature = (feature) => {
    return features && (features.includes(feature))
  };

  const options = [
    { value: 0, label: 'Cancel' },
    { value: 1, label: 'Save and Exit' }
  ]
  
  if (hasFeature('custom_choices')) {
    options.push({ value: 9, label: `Custom ${!isApp ? 'Javascript' : 'Action'}` })
  }

  const changeValue = (value, data = {}, optionalKeypairs = {}) => {

    if (value === 9) data = new ExecJS(data).toJS();

    if (data.hasOwnProperty('enabled')) delete data.enabled;
    data.button_text = JSON.stringify(Date.now());

    updateSetting(settingKey, {
      type: value,
      data,
      ...optionalKeypairs
    });
  }

  return (
    <div className="four-options">
      <h4>{settingsTitle}</h4>
      <div className="option-inputs">
        <Select
          value={value.type}
          onChange={(val => changeValue(val))}
          options={options}
        />
      </div>
      <div className="option-details">
        {(value.type === 9) && (
          <CustomJSComp
            changeValue={changeValue}
            value={value}
            isApp={isApp}
          />
        )}
      </div>
    </div>
  )
}

export default PreferencesActionOptions